import { render, staticRenderFns } from "./_TodoCreate.vue?vue&type=template&id=068ac57c&scoped=true&"
import script from "./_TodoCreate.vue?vue&type=script&lang=js&"
export * from "./_TodoCreate.vue?vue&type=script&lang=js&"
import style0 from "./_TodoCreate.vue?vue&type=style&index=0&id=068ac57c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068ac57c",
  null
  
)

export default component.exports